export const AUTH_APP_ID_KEY = 'auth_app_id';
export const NON_RENEWING_SUBSCRIPTION_KEY = 'Non renewing';
export const DEFAULT_LOCALE = 'en';
export enum RM_TAGS {
  VideoPage = 'VideoPage',
  PathwayPage = 'PathwayPage',
  ExpertPage = 'ExpertPage',
  TestPage = 'TestPage',
  TermPage = 'TermPage',
  CategoryPage = 'CategoryPage',
  CourseSharePage = 'CourseSharePage',
  PathwaySharePage = 'PathwaySharePage',
  CoursePage = 'CoursePage',
  CourseProgressPage = 'CourseProgressPage',
  TeamPage = 'TeamPage',
  InviteToTeamPage = 'InviteToTeamPage',
  SinglePlanPage = 'SinglePlanPage',
  JoinTeamPage = 'JoinTeamPage',
}
